import { Component, inject } from '@angular/core';
import { CommonModule, DatePipe, formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { DataService } from '../../../services/data.service';

declare var $: any;

@Component({
	selector: 'app-trial-info',
	imports: [CommonModule],
	providers: [DatePipe],
	templateUrl: './trial-info.component.html',
	styleUrl: './trial-info.component.scss',
})
export class TrialInfoComponent {
	datePipe = inject(DatePipe);
	trialDays: number = 7;
	dayConsumed: number = 1;
	dayRemains: number = 0;
	trialUsage: number = 0;		// for persontage %
	extraDays: number = 0;
	// is_agree: any = null;
	
	expDate: any = '';
	user: any = '';

	constructor(private router: Router, public dataService: DataService) {
		//
	}

	ngOnInit() {
		// this.is_agree = localStorage.getItem("agreement");
		let erp_rem: any = localStorage.getItem("erp_rem");

		if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
			erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;

			const curDate: Date = new Date();
			const expDate1 = this.dataService.getFutureDate(this.user.cur_date, this.trialDays);
			//this.expDate = this.datePipe.transform(expDate1, 'yyyy-MM-dd');
			this.expDate = this.user.exp_date;
			
			this.dayRemains = this.dataService.getDaysDiff(curDate, expDate1);
			this.dayConsumed = this.trialDays - this.dayRemains;

			if(this.dayRemains > this.trialDays) {
				this.extraDays = this.dayRemains - this.trialDays;
			}
			
			this.trialUsage = parseFloat(((this.dayConsumed * 100) / this.trialDays).toFixed(2));

			// if(this.is_agree && this.is_agree == 'read' && this.dayRemains > -1) {
			if(this.dayRemains > -1) {
				$('#staticBackdrop1').modal('hide');
				$('#staticBackdrop2').modal('hide');
				$('#staticBackdrop3').modal('hide');
				// this.router.navigate(['/dashboard']);
			}
		}
	}

	upgrade() {
		$('#staticBackdrop1').modal('hide');
		this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('kyc')]);

		// if(this.is_agree == 'read') {
		// 	setTimeout(()=>{
		// 		this.router.navigate(['/dashboard']);
		// 	}, 500);	
		// } else {
		// 	setTimeout(()=>{
		// 		this.router.navigate(['/dashboard/agreement']);
		// 	}, 500);
		// }
	}

	continue() {
		// if(this.is_agree == 'read') {
			setTimeout(()=>{
				this.router.navigate(['/dashboard/home']);
			}, 500);
		// } else {
		// 	setTimeout(()=>{
		// 		this.router.navigate(['/dashboard/agreement']);
		// 	}, 500);
		// }
	}
}
